import React, {useState, Fragment} from "react";
import {TabContent, TabPane} from "reactstrap";
import PropTypes from "prop-types";
import TabsHeader from "./TabsHeader";
import "./style.scss";

function Tabs(props) {
  const {
    list,
    defaultActive = list[0].key,
    handleChange = () => {},
    ...relatedProps
  } = props;

  const [activeTab, setActiveTab] = useState(defaultActive);

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      handleChange(tab);
    }
  };

  return (
    <Fragment>
      <TabsHeader list={list} handleClick={toggle} activeTab={activeTab} />
      <TabContent activeTab={activeTab}>
        {list.map((tab) => (
          <TabPane tabId={tab.key} key={tab.key}>
            {activeTab === tab.key ? <tab.Component {...relatedProps} /> : null}
          </TabPane>
        ))}
      </TabContent>
    </Fragment>
  );
}

Tabs.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
      Component: PropTypes.element,
    })
  ).isRequired,
  defaultActive: PropTypes.string,
  handleChange: PropTypes.func,
};

export default Tabs;
